export function useUrlHelper() {
  function addParams(paramObj: any, url: string, encode: boolean = false) {
    const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    let params = [];

    for (let key in paramObj) {
      if (paramObj.hasOwnProperty(key)) {
        let paramValue = paramObj[key];

        // Check: format is date-time
        if (encode === true && dateTimeRegex.test(paramValue) === false) {
          paramValue = encodeURIComponent(paramValue);
        }

        params.push(`${key}=${paramValue}`);
      }
    }

    const paramString = params.join('&');
    const updatedUrl = url.split('?')[0] + '?' + paramString;

    return updatedUrl;
  }

  return {
    addParams,
  };
}